const style: React.CSSProperties = {
  whiteSpace: "nowrap",
  color: "rgb(34, 0, 102)",
};

/** wrap abstract phonemes in slashes, without word-wrap */
export function PSlash(props: { readonly children: string; }) {
  const str = '/' + props.children + '/';
  return <span style={style}>{str}</span>;
}

/** wrap detailed phonemes in square brackets, without word-wrap */
export function PSquare(props: { readonly children: string; }) {
  const str = '[' + props.children + ']';
  return <span style={style}>{str}</span>;
}

/** wrap detailed phonemes in orthography delimiters, without word-wrap */
export function POrtho(props: { readonly children: string; }) {
  const str = '⟨' + props.children + '⟩';
  return <span style={style}>{str}</span>;
}
